import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { TextField } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import OptionsSource from '../OptionsSource';
import FormOptionColor from '../../../FormOptionColor';
import Edit from '../Edit';
import mes from '../../intl';
import './Select.scss';

/**
 * Компонент Select Constructor
 */
class Select extends PureComponent {
  constructor(props) {
    super(props);
    this.handleInitOptions = this.handleInitOptions.bind(this);
    this.handleRemoveAnswer = this.handleRemoveAnswer.bind(this);
    this.handleAnswersChange = this.handleAnswersChange.bind(this);
    this.handleAddAnswer = this.handleAddAnswer.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  componentDidMount() {
    const { options } = this.props;
    // Добавить пустой ответ
    if (this.addAnswerEl && (!options || !options.length))
      this.addAnswerEl.click();
  }

  // Выделить последний элемент выбора
  _focusLastOption(type) {
    if (!this.itemsBox) return;
    const inputs = this.itemsBox.getElementsByTagName('input');
    const inLen = inputs.length;
    if (type === 'add' && inLen <= 1) return;
    const lastInput = inputs[inLen - 1];
    if (!lastInput) return;
    lastInput.focus();
  }

  // Ввод статического ответа
  handleAnswersChange({ index, value, title, color }) {
    const { id, onChange } = this.props;
    const options = this.props.options.slice();
    options.splice(index, 1, { value, title, color });
    onChange({ fieldId: 'options', id, value: options });
  }

  // Удаление статического ответ
  handleRemoveAnswer(index, optLen) {
    if (optLen <= 1) return;
    const { id, onChange } = this.props;
    const options = this.props.options.slice();
    options.splice(index, 1);
    onChange({ fieldId: 'options', id, value: options });
    setTimeout(() => this._focusLastOption('remove'), 10);
  }

  // Добавление нового статического ответа
  handleAddAnswer() {
    const { id, onChange } = this.props;
    let options = this.props.options || [];
    options = options.slice();
    options.push({ value: AppUtils.createRid(), title: '' });
    onChange({ fieldId: 'options', id, value: options });
    setTimeout(() => this._focusLastOption('add'), 10);
  }

  // По enter создать новый option
  handleKeyUp(e) {
    if (e.key !== 'Enter') return;
    this.handleAddAnswer();
  }

  handleInitOptions() {
    const { onChange } = this.props;
    onChange({
      fieldId: 'options',
      value: [{ value: AppUtils.createRid(), title: '' }],
    });
  }

  renderItems(options) {
    const { className, onChange, isActive } = this.props;
    const isRadio = className === 'radio';
    options = options || [];
    // Если в поле options переменная
    if (typeof options === 'string') {
      return (
        <div styleName="select__item">
          {isRadio ? <div styleName="select__item__radio" /> : <div>1.</div>}
          <TextField
            id="options"
            value={options}
            placeholder={this.i(mes.answerOption)}
            rightIcon="close"
            onClickRightIcon={this.handleInitOptions}
            onChange={({ value }) => onChange({ fieldId: 'options', value })}
          />
        </div>
      );
    }
    // Если в поле options массив
    return options.map((i, index) => (
      <div key={i.value || index} styleName="select__item">
        {isRadio ? (
          <div styleName="select__item__radio" />
        ) : (
          <div>{index + 1}.</div>
        )}
        <TextField
          id={i.value}
          value={i.title}
          placeholder={this.i(mes.answerOption)}
          rightIcon={isActive ? 'close' : null}
          onClickRightIcon={() =>
            this.handleRemoveAnswer(index, options.length)
          }
          onChange={({ id, value }) => {
            this.handleAnswersChange({
              index,
              value: id,
              title: value,
              color: i.color,
            });
          }}
          onKeyUp={this.handleKeyUp}
        />
        <FormOptionColor
          value={i.color}
          onChange={({ hex }) =>
            this.handleAnswersChange({ index, ...i, color: hex })
          }
        />
      </div>
    ));
  }

  render() {
    const { options, extra, isActive, className } = this.props;
    const needOptions =
      !extra.optionsSource ||
      (extra.optionsSource && extra.optionsSource.type === 'manual');
    const isRadio = className === 'radio';
    return (
      <div styleName="select">
        <div styleName="select__title">
          <Edit {...this.props} />
        </div>
        {!isRadio ? (
          <OptionsSource
            handleInitOptions={this.handleInitOptions}
            {...this.props}
          />
        ) : null}
        {needOptions ? (
          <div styleName="select__options" ref={(el) => (this.itemsBox = el)}>
            {this.renderItems(options)}
            {typeof options !== 'string' && isActive ? (
              <div
                ref={(el) => {
                  this.addAnswerEl = el;
                }}
                styleName="select__options__add"
                onClick={this.handleAddAnswer}
              >
                {this.i(mes.addOption)}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

Select.defaultProps = {
  extra: {},
};

Select.propTypes = {
  id: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  extra: PropTypes.object,
  isActive: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

Select.contextTypes = {
  intl: intlShape,
};

export default injectIntl(Select);
